var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelationPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.522,
    height: 19.563,
    viewBox: "0 0 20.522 19.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776",
    transform: "translate(2.9 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763",
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M15.007,19.563H2.384a2.385,2.385,0,0,1,0-4.769H3.13V2.387A2.39,2.39,0,0,1,5.516,0h12.62a2.386,2.386,0,0,1,0,4.772H17.39V11H15.753l0-8.613a2.379,2.379,0,0,1,.119-.746H5.517a.747.747,0,0,0-.746.746V14.794H9.4v1.639H2.388a.747.747,0,1,0,0,1.493H9.4V18h7.843A2.4,2.4,0,0,1,15.007,19.563ZM17.674,1.8h0a.736.736,0,0,0-.286.589v.746h.747A.746.746,0,1,0,17.678,1.8ZM9.4,12.829H5.968V11.192H9.4v1.636Zm5.08-3.341H5.968V7.852H14.48V9.487Zm0-3.34H5.968V4.512H14.48V6.147Z",
    transform: "translate(2.1 2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-cross",
    "data-name": "Icon akar-cross",
    d: "M11.053,11.053,6,6m5.053,0L6,11.053",
    transform: "translate(1.619 7.922)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelationPolicy);
export default __webpack_public_path__ + "static/media/CancelationPolicy.78ebb734a839d8d62711fd2c9bf30cef.svg";
export { ForwardRef as ReactComponent };